import gql from "graphql-tag";

export default ({ variables }) => ({
  query: gql`
    query customer {
      customer {
        date_of_birth
        default_billing
        default_shipping
        email
        firstname
        is_subscribed
        lastname
        middlename
        prefix
        suffix
        taxvat
        nickname
        avatar_url
        phone_number
        id_hash
        addresses {
          city
          country_code
          default_billing
          default_shipping
          extension_attributes {
            attribute_code
            value
          }
          firstname
          id
          lastname
          postcode
          prefix
          region {
            region_code
            region_id
            region
          }
          street
          suffix
          telephone
          vat_id
        }
        is_subscribed
      }
    }
  `,
  variables,
});
